import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { Markup } from "../../../../internal/Markup";
import { TextBase } from "../../../../internal/TextBase";
import { SearchLink } from '../SearchLink';
import styles from './SearchSubMenuItems.css';
var cx = classNames.bind(styles);
export var SearchSubMenuItems = function SearchSubMenuItems(_ref) {
  var group = _ref.group,
      onClose = _ref.onClose,
      searchValue = _ref.searchValue,
      theme = _ref.theme;
  return /*#__PURE__*/React.createElement("div", {
    key: group.title,
    className: cx('root', "theme_".concat(theme), {
      has_search_value: Boolean(searchValue)
    })
  }, /*#__PURE__*/React.createElement(TextBase, {
    as: "span",
    size: "l",
    weight: "semibold"
  }, /*#__PURE__*/React.createElement(Markup, {
    text: group.title
  })), /*#__PURE__*/React.createElement("ul", {
    className: cx('items')
  }, group.points && group.points.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.title,
      className: cx('item')
    }, /*#__PURE__*/React.createElement(SearchLink, _extends({
      theme: theme,
      onClick: onClose,
      searchValue: searchValue
    }, item)));
  })));
};